module.exports = __webpack_public_path__ + "789a0b936fc8d787ea160313512decb0.svg";